// FAQ Liquid & product tab liquid Start
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
// FAQ Liquid & product tab liquid end
// coupon Liquid Start
document.addEventListener("DOMContentLoaded", function () {
  let initialized = false;
  let currentIndex = 0;

  function initializeSlider() {
    const couponslider = document.querySelector(".coupon-slide");
    const couponslides = document.querySelectorAll(".coupon_list");
    let couponprevButton = document.querySelector(".prev-btn");
    let couponnextButton = document.querySelector(".next-btn");
    couponprevButton.style.display = "block";
    couponnextButton.style.display = "block";

    if (
      !couponslider ||
      couponslides.length <= 1 ||
      window.innerWidth > 899 ||
      initialized
    ) {
      return;
    }

    initialized = true;

    couponslider.style.display = "flex";
    couponslider.style.overflowX = "auto";
    couponslider.style.scrollBehavior = "smooth";
    couponslider.style.flexWrap = "nowrap";

    couponslides.forEach((slide) => {
      slide.style.minWidth = "40%";
      slide.style.flexShrink = "0";
    });
    function moveToSlide(index) {
      if (index < 0) index = couponslides.length - 1;
      if (index >= couponslides.length) index = 0;
      currentIndex = index;
      couponslider.scrollLeft = couponslider.offsetWidth * index;
    }

    couponprevButton.addEventListener("click", () =>
      moveToSlide(currentIndex - 1)
    );
    couponnextButton.addEventListener("click", () =>
      moveToSlide(currentIndex + 1)
    );
  }

  if (window.innerWidth <= 899) {
    initializeSlider();
  }

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.innerWidth <= 899 && !initialized) {
        initializeSlider();
      }
    }, 300);
  });
});

// coupon Liquid end
// Header Liquid start
let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const dropbtn = document.querySelector(".dropbtn");
  const dropdown = document.querySelector(".dropdown-content");
  dropbtn.addEventListener("click", function (e) {
    e.stopPropagation();
    dropdown.classList.toggle("show");
  });
  document.addEventListener("click", function () {
    dropdown.classList.remove("show");
  });
  dropdown.addEventListener("click", function (e) {
    e.stopPropagation();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const scentList = document.querySelector(".scent-list");
  const scentItems = document.querySelectorAll(".scent_type_listing");
  const prevBtn = document.getElementById("prevBtn");
  const nextBtn = document.getElementById("nextBtn");

  if (!scentList || !prevBtn || !nextBtn || scentItems.length === 0) {
    console.log("One or more required elements not found!");
    return;
  }

  let currentIndex = 0;
  const visibleItems = 10;
  const itemWidth = scentItems[0].offsetWidth + 10; // Item width + spacing

  function updateSlider() {
    scentList.style.transition = "transform 0.3s ease-in-out";
    scentList.style.transform = `translateX(${-currentIndex * itemWidth}px)`;
    updateButtons();
  }

  function updateButtons() {
    prevBtn.classList.toggle("disabled", currentIndex === 0);
    nextBtn.classList.toggle(
      "disabled",
      currentIndex >= scentItems.length - visibleItems
    );
  }

  nextBtn.addEventListener("click", () => {
    if (currentIndex < scentItems.length - visibleItems) {
      currentIndex++;
      updateSlider();
    }
  });

  prevBtn.addEventListener("click", () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  });

  // Drag Functionality (Optional for extra UX)
  let isDragging = false,
    startX,
    scrollLeft;

  scentList.addEventListener("mousedown", (e) => {
    isDragging = true;
    startX = e.pageX - scentList.offsetLeft;
    scrollLeft = scentList.scrollLeft;
    scentList.style.cursor = "grabbing";
  });

  scentList.addEventListener("mouseleave", () => {
    isDragging = false;
  });

  scentList.addEventListener("mouseup", () => {
    isDragging = false;
    scentList.style.cursor = "grab";
  });

  scentList.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scentList.offsetLeft;
    const walk = (x - startX) * 2;
    scentList.scrollLeft = scrollLeft - walk;
  });

  updateSlider(); // Initial state
});

// Main collection product grid Liquid end
// popup liquid start
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    let popupBackdrop = document.querySelector(".custom_Pop-up_backdrop");
    if (popupBackdrop) {
      popupBackdrop.classList.add("active");
    }
  }, 5000);
  let closeButton = document.querySelector(".close-PopUp");
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      let popupBackdrop = document.querySelector(".custom_Pop-up_backdrop");
      if (popupBackdrop) {
        popupBackdrop.classList.remove("active");
      }
    });
  }
});
//popup liquid end
//trust badges liquid start
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".small-slider");
  if (slider) {
    const slides = slider.querySelectorAll(".grid__itemcc");
    if (slides.length === 0) {
      console.error("No slides found inside the slider!");
      return;
    }

    let currentIndex = 0;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.remove("active");
        slide.style.opacity = "0";
        slide.style.transition = "opacity 0.5s ease-in-out";
        slide.style.display = i === index ? "block" : "none";
      });

      setTimeout(() => {
        slides[index].style.opacity = "1";
        slides[index].classList.add("active");
      }, 10);
    }

    function nextSlide() {
      slides[currentIndex].classList.remove("active");
      slides[currentIndex].style.opacity = "0";
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    }

    function prevSlide() {
      slides[currentIndex].classList.remove("active");
      slides[currentIndex].style.opacity = "0";
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(currentIndex);
    }

    showSlide(currentIndex);
  }
  setInterval(nextSlide, 3000);
});

function showDropdown() {
  let dropdown = document.getElementById("SortByDropdown");
  dropdown.style.display = dropdown.style.display === "none" ? "block" : "none";
}

function showDropdown1() {
  let dropdown = document.getElementById("SortByDropdown1");
  dropdown.style.display = dropdown.style.display === "none" ? "block" : "none";
}
document.addEventListener("click", (event) => {
  if (!event.target.closest("#showSortByDropdown")) {
    const dropdown = document.getElementById("SortByDropdown");
    if (dropdown && dropdown.style.display === "block") {
      dropdown.style.display = "none";
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("toggle-share");

  if (toggleButton) {
    toggleButton.addEventListener("click", function () {
      const shareList = document.getElementById("social-share-list");
      if (shareList) {
        shareList.style.display =
          shareList.style.display === "none" || shareList.style.display === ""
            ? "block"
            : "none";
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("ContactForm");
  if (!form) return;

  const emailField = document.getElementById("ContactForm-email");
  const nameField = document.getElementById("ContactForm-name");
  const phoneField = document.getElementById("ContactForm-phone");
  const messageField = document.getElementById("ContactForm-body");

  form.addEventListener("submit", function (event) {
    let valid = true;
    document
      .querySelectorAll(".contact__field-error")
      .forEach((el) => el.remove());

    if (nameField.value.trim() === "") {
      showError(nameField, "Name is required.");
      valid = false;
    } else if (/\d/.test(nameField.value)) {
      showError(nameField, "Name cannot contain numbers.");
      valid = false;
    }

    if (emailField.value.trim() === "") {
      showError(emailField, "Email is required.");
      valid = false;
    } else if (!isValidEmail(emailField.value)) {
      showError(emailField, "Invalid email format.");
      valid = false;
    }

    const phoneDigits = phoneField.value.replace(/\D/g, "");
    if (phoneDigits.length !== 10) {
      showError(phoneField, "Phone number must be exactly 10 digits.");
      valid = false;
    }

    if (messageField.value.trim() === "") {
      showError(messageField, "Message is required.");
      valid = false;
    }

    if (!valid) event.preventDefault();
  });

  function showError(field, message) {
    const errorElement = document.createElement("small");
    errorElement.classList.add("contact__field-error");
    errorElement.style.color = "red";
    errorElement.textContent = message;
    field.parentElement.appendChild(errorElement);
    field.focus();
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  nameField.addEventListener("input", function () {
    this.value = this.value.replace(/\d/g, "");
  });

  phoneField.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9]/g, "");
    if (this.value.length > 10) {
      this.value = this.value.slice(0, 10);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const phoneTrigger = document.getElementById("Phone-tooltip-trigger");
  const phoneContent = document.getElementById("Phone-tooltip-content");

  const whatsappTrigger = document.getElementById("Whatsaap-tooltip-trigger");
  const whatsappContent = document.getElementById("WhatsApp-tooltip-content");

  if (phoneTrigger && phoneContent) {
    phoneTrigger.addEventListener("mouseenter", () => {
      phoneContent.style.display = "block";
    });
    phoneTrigger.addEventListener("mouseleave", () => {
      phoneContent.style.display = "none";
    });
  }

  if (whatsappTrigger && whatsappContent) {
    whatsappTrigger.addEventListener("mouseenter", () => {
      whatsappContent.style.display = "block";
    });
    whatsappTrigger.addEventListener("mouseleave", () => {
      whatsappContent.style.display = "none";
    });
  }
});
